export default __webpack_public_path__ + "static/media/output.fa5e2873.webm";